import request from "./axios";

function index(params) {
  params.assigned_to = params.filter.assigned
  params.lead_type = params.filter.lead_type
  params.booking_from = params.filter.booking_from
  params.business_stream = params.filter.business_stream
  delete(params.filter)
  return request({
    method: "get",
    url: `/leads`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/leads/${id}`,
  })
}

function update(id, params) {
  return request({
    method: "patch",
    url: `/leads/${id}`,
    data: { lead: params }
  })
}

function takeAction(action, id, params) {
  return request({
    method: "post",
    url: `/leads/${id}/action/${action}`,
    data: { lead_action: params }
  })
}

function sendGroupMessage(params) {
  return request({
    method: "post",
    url: `/leads/send_group_message`,
    data: params
  })
}

function groupAction(action, params) {
  return request({
    method: "post",
    url: `/leads/group_action/${action}`,
    data: params
  })
}

function stats() {
  return request({
    method: "get",
    url: `/leads/stats`
  })
}

const LeadsService = {
  index, get, takeAction, sendGroupMessage, groupAction, stats, update
};

export default LeadsService;
